<template>
  <vmodal :modal.sync="modal" title="审核" :btns="btns" :width="500">
    <el-form ref="form" label-width="100px" :model="form">
      <el-row>
        <el-col :span="24">
          <el-form-item prop="Status" label="审核结果:" :rules="[{ required: true, message: '请选择审核结果', trigger: 'blur' }]">
            <!-- <el-input type="text" placeholder="接口地址" v-model="form.Url" style="width: 100% "></el-input> -->
            <el-radio-group v-model="form.Status">
              <el-radio label="1">通过</el-radio>
              <el-radio label="0">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item prop="Remark" label="备注:" :rules="[{ required: true, message: '请输入备注', trigger: 'blur' }]">
            <el-input type="textarea" placeholder="审核备注..." v-model="form.Remark" style="width: 100% "></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </vmodal>
</template>
<script>
import vmodal from "@/components/Modal.vue";
export default {
  components: { vmodal },
  props: {
    id: {//编辑时传进来id
      type: [String, Number],
      default: ""
    }, onSuccess: {//操作成功时的方法
      type: Function,
      default: function () {
      }
    }, url: {//请求接口的url:api/xxx/Audit
      type: String,
      default: ""
    }
  },
  watch: {//监听 modal 值的变化,如果是显示的时候就重新获取表单信息
    modal: {
      handler(IsShow) {
        if (IsShow) {
          this.reSetForm();
          this.form.Id = this.id;
        }
      },
      deep: true
    }
  },

  data() {
    return {
      modal: false,
      form: {
        Id: '',
        Status: '',
        Remark: '',
      },
      btns: [
        {
          text: "保存",
          type: 'success',
          icon: 'el-icon-check',
          click: (row, column, event) => {
            this.OnSubmit();
          }
        }
      ],
    };
  },
  methods: {
    reSetForm() {//重置表单
      if (this.$refs['form'] != undefined) {
        this.$refs['form'].resetFields();//重置表单，并关闭掉验证内容
        let data = this.$options.data.call(this.form);
        Object.assign(this.form, data.form);//设置表单为初始值
      }
    },
    OnSubmit() {
      let isSuccess = true;
      this.$refs['form'].validate((valid) => {
        if (!valid) {
          isSuccess = false;
        }
      });
      if (!isSuccess) {
        return;
      }
      this.http.post(this.url, this.form).then(ret => {
        if (ret.Code == 1) {
          this.modal = false;
          this.$message({ type: 'success', message: '操作成功!' });
          if (this.onSuccess) {
            this.onSuccess && this.onSuccess();
          }
        } else {
          this.$message.error(ret.Message);
        }
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Audit.vue